const emailValidation = (text: string) => {
  // Bloqueia caracteres não-latinos (árabe, coreano, japonês, etc)
  // eslint-disable-next-line no-control-regex
  if (!/^[\x00-\x7F\u00C0-\u00FF]+$/.test(text)) return false;

  const isEmail = text.match(
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  );

  if (isEmail) return true;

  return false;
};

export default emailValidation;
